import { PeriodValue } from './DateRangePicker.types'

export const parsePeriodToDates = (period: PeriodValue): Date[] => {
  if (!period) return null
  return [new Date(period.start.valueOf()), new Date(period.end.valueOf())]
}
